/*
 * Butoanele din ofertele de cos: upgrade la varianta superioara si adaugarea
 * celorlalte produse.
 *
 * Upgrade-ul e stergere + adaugare: API-ul de cos al Shopify nu poate schimba varianta
 * unei linii existente. Cantitatea si proprietatile liniei se citesc inainte si se duc
 * mai departe, altfel omul si-ar pierde in tacere ce avea acolo.
 *
 * Ascultatorul e delegat de pe document: Dawn rescrie interiorul sertarului la fiecare
 * modificare, deci un handler legat direct pe buton s-ar pierde dupa prima apasare.
 */
(function () {
  if (window.__nkCartOffersInit) return;
  window.__nkCartOffersInit = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;

  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) { window.location.reload(); return; }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('cart-drawer');
        var live = document.querySelector('cart-drawer');
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          /* Doar is-empty. Copierea intregului className stergea "active", clasa
             cu care Dawn tine sertarul deschis, si sertarul disparea. */
          live.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          var fi = fresh.querySelector('cart-drawer-items');
          var li = live.querySelector('cart-drawer-items');
          if (fi && li) li.className = fi.className;
        }
        var fb = parsed.querySelector('#cart-icon-bubble');
        var lb = document.querySelector('#cart-icon-bubble');
        if (fb && lb) lb.innerHTML = fb.innerHTML;
        // pe pagina de cos nu exista sertar: acolo reincarcam
        if (!live) window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  function markBusy(btn) {
    busy = true;
    btn.setAttribute('disabled', 'disabled');
    var label = btn.getAttribute('data-busy-label');
    if (label) { btn.setAttribute('data-old-label', btn.innerHTML); btn.innerHTML = label; }
  }

  function addVariant(id, qty, props) {
    var item = { id: id, quantity: qty || 1 };
    if (props) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS,
      body: JSON.stringify({ items: [item] })
    });
  }

  document.addEventListener('click', function (e) {
    // ---- upgrade ----
    var up = e.target.closest('[data-nk-upgrade-btn]');
    if (up && !busy) {
      e.preventDefault();
      var card = up.closest('[data-nk-upgrade]');
      if (!card) return;
      var target = Number(card.getAttribute('data-variant'));
      var line = parseInt(card.getAttribute('data-line'), 10);
      if (!target || !line) return;
      markBusy(up);

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var old = cart.items[line - 1] || {};
          var qty = old.quantity || 1;
          var props = old.properties || null;
          // intai scoatem linia veche, apoi punem varianta noua
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS,
            body: JSON.stringify({ line: line, quantity: 0 })
          }).then(function () { return addVariant(target, qty, props); });
        })
        .then(refreshCart)
        .catch(function () {})
        .then(function () { busy = false; });
      return;
    }

    // ---- adauga alt produs ----
    var add = e.target.closest('[data-nk-add-btn]');
    if (add && !busy) {
      e.preventDefault();
      var row = add.closest('[data-nk-add]');
      var sel = row ? row.querySelector('[data-nk-add-select]') : null;
      var vid = sel ? Number(sel.value) : Number(add.getAttribute('data-variant'));
      if (!vid) return;
      markBusy(add);
      addVariant(vid, 1)
        .then(refreshCart)
        .catch(function () {})
        .then(function () { busy = false; });
    }
  });
})();
